import * as Yup from 'yup';

export const CruiseFormSchema = () =>
  Yup.object({
    code: Yup.string().default(''),
    name: Yup.string().default(''),
    email: Yup.string().email().default(''),
    phone: Yup.string().nullable().default(''),
    phone_2: Yup.string().nullable().default(''),
    cruiseRooms: Yup.array()
      .of(
        Yup.object({
          id: Yup.string().nullable(),
          type: Yup.string().default(''),
          size: Yup.string().default(''),
          description: Yup.string().nullable().default(''),
        }).required(),
      )
      .default([]),
    contact: Yup.object({
      id: Yup.string(),
      name: Yup.string().default(''),
      email: Yup.string().email().default(''),
      phone: Yup.string().default(''),
      description: Yup.string().nullable().default(''),
    }).required(),
    cruiseShips: Yup.array()
      .of(Yup.object({ name: Yup.string().default('') }))
      .default([]),
  });

export type CruiseFormType = Yup.InferType<ReturnType<typeof CruiseFormSchema>>;
